import { render, staticRenderFns } from "./tzsmrz.vue?vue&type=template&id=59456172&scoped=true&"
import script from "./tzsmrz.vue?vue&type=script&lang=js&"
export * from "./tzsmrz.vue?vue&type=script&lang=js&"
import style0 from "./tzsmrz.vue?vue&type=style&index=0&id=59456172&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59456172",
  null
  
)

export default component.exports